export const DEFAULT_LOCAL_RESERVATION_ID =
	'11111111-bbbb-bbbb-bbbb-bbbbbbbbbbbb'
